<div class="main-toolbar mat-elevation-z2">
  <div fxLayout="row" fxLayoutAlign="start center" fxHide="false" fxHide.gt-sm>
    <button (click)="sidenav.open()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>
</div>
